<template>
  <div class="detail-wrapper">
    <div class="padding-lr-sm flex align-center">
      <el-button type="primary" @click="setLevel = true">设置建议评估等级</el-button>
      <el-link :href="exportExcelFile" target="_blank" class="margin-left-xs" :underline="false">
        <el-button type="warning">导出评估打分表</el-button>
      </el-link>

    </div>

    <div class="detail-box padding-lr-sm margin-top">
      <h2>{{ title }}（{{ year }}版）</h2>
      <div class="flex align-center justify-between info-item">
        <div>评估机构名称（盖章）：</div>
      </div>
      <div class="flex align-center justify-between info-item">
        <div>参评社会组织：{{ orgInfo.title }}</div>
        <div>统一社会信用代码：{{ orgInfo.credit_code }}</div>
      </div>
      <table class="top-table">
        <tr>
          <td :colspan="fristList.length-1" class="active left">评 估 总 分： ( {{ orgInfo.total_points }} )分 建议评估等级：
            ({{ orgInfo.total_level === 0 ? '  ' : orgInfo.total_level }})A级
          </td>
          <td :colspan="2" class="active left">评估总分复核人：</td>
        </tr>
        <tr>
          <td class="active">一 级 指 标</td>
          <td class="active" v-for="(item,index) in fristList" :key="item.id">{{ index + 1 }}.{{ item.name }}</td>
        </tr>
        <tr>
          <td class="active">评 估 得 分</td>
          <td class="active" v-for="item in fristList" :key="item.id">{{ item.total_score }}</td>

        </tr>
        <tr>
          <td class="active">评 估 得 分 率</td>
          <td class="active" v-for="item in fristList" :key="item.id">{{ item.toatla_lv }}%</td>

        </tr>
        <tr>
          <td class="active">评 估 专 家</td>
          <td class="active" v-for="item in fristList" :key="item.id"></td>

        </tr>
      </table>

      <div class="matters">
        <h3 class="matters-title">注意事项:</h3>
        <div class="matters-content" v-html="content">
        </div>
      </div>

      <div class="score-box" v-for="(item,index) in tableData" :key="index">

        <div class="flex align-center justify-between margin-top-sm">
          <h3>专家签字：</h3>
          <h3>{{ title }}（{{ year }}版）--{{ index + 1 }}.{{ item.name }}</h3>
          <h3></h3>
        </div>
        <table class="score-table">
          <tr>
            <td class="active" style="width: 8%">一级指标</td>
            <td class="active" style="width: 8%">二级指标</td>
            <td class="active" style="width: 8%">三级指标</td>
            <td class="active" style="width: 8%">四级指标</td>
            <td class="active" style="width: 40%">打分细则</td>
            <td class="active" style="width: 30px">分值</td>
            <td class="active" style="width: 30px">得分</td>
            <td class="active">备注</td>
            <td class="active" style="width: 20%">扣分理由</td>
          </tr>

          <template v-for="(frist,oneIndex) in item.child">
            <template v-for="(two,twoIndex) in frist.child">
              <template v-for="(three,threeIndex) in two.child">
                <tr :key="index +'-'+oneIndex+'-'+twoIndex+'-'+threeIndex">
                  <td :rowspan="item.total_num" v-if="threeIndex === 0 && twoIndex === 0 && oneIndex === 0">
                    {{ index + 1 }}.{{ item.name }}({{ item.total_points }}分)
                  </td>
                  <td :rowspan="frist.total_num" v-if="threeIndex === 0 && twoIndex === 0 ">{{
                      index + 1
                    }}.{{ oneIndex + 1 }} {{ frist.name }}（{{ frist.total_points }}分）
                  </td>
                  <td :rowspan="two.total_num" v-if="threeIndex === 0">{{ index + 1 }}.{{
                      oneIndex + 1
                    }}.{{ twoIndex + 1 }} {{
                      two.name
                    }}（{{ two.total_points }}分）
                  </td>
                  <td>{{ index + 1 }}.{{ oneIndex + 1 }}.{{ twoIndex + 1 }}.{{ threeIndex + 1 }} {{
                      three.name
                    }}（{{ three.total_points }}分）
                  </td>
                  <td>
                    <div v-html="three.content"></div>
                  </td>
                  <td style="text-align: center;">{{ three.total_points }}</td>
                  <td @click="editScore(three)" class="center"
                      style="color: #368ad1;cursor: pointer;text-align: center;">{{
                      three.score === -1 ? '无涉指标' : three.score
                    }}
                  </td>
                  <td style="text-align: center;">{{ three.is_focus === 1 ? '*' : '' }}</td>
                  <td>{{ three.remark }}</td>
                </tr>
              </template>
            </template>
          </template>

          <tr>
            <td colspan="5" style="text-align: center">合计</td>
            <td style="text-align: center;">{{ item.total_points }}</td>
            <td style="text-align: center;">{{ item.score }}</td>
            <td></td>
            <td></td>
          </tr>
        </table>

      </div>


    </div>


    <setLevel :level="orgInfo.total_level" :setLevel="setLevel" @cancelDialog="cancelDialog"/>

    <setScore :setItem="setItem" :setScore="setScore" @cancelDialog="cancelDialog"/>

  </div>
</template>

<script>
import setLevel from "@/views/admin/dialog/setLevel";
import setScore from "@/views/admin/dialog/setScore";
import {getOrgDetail} from "@/api/admin";
import {exportExcelFile} from "@/config";
import {getToken} from "@/utils";

export default {
  name: "estimateOrgShow",
  data() {
    return {
      year: '',
      title: '',
      content: '',
      orgInfo: {
        credit_code: "",
        title: "",
        total_level: 0,
        total_points: 0
      },
      fristList: [],
      tableData: [],
      setLevel: false,

      setItem: null,
      setScore: false
    }
  },
  created() {
    this.$emit("setIndex", '/admin/scoreList', "参评社会组织打分表详情", true);
    this.getDetail()
  },
  computed: {
    token() {
      let _token = getToken().token
      return _token
    },
    exportExcelFile() {
      return exportExcelFile + '?token=' + this.token + '&id=' + this.$route.params.id
    }
  },
  components: {setLevel, setScore},
  methods: {
    //  修改分数
    editScore(item) {
      this.setItem = item
      this.setScore = true
    },
    //  设置等级
    cancelDialog(state) {
      this.setLevel = false
      this.setScore = false
      this.setItem = null
      if (state) this.getDetail()
    },
    //  获取打分表详情
    async getDetail() {
      const res = await getOrgDetail(this.$route.params.id)
      this.year = res.data.playingData.year
      this.title = res.data.playingData.name
      this.content = res.data.playingData.content
      this.fristList = res.data.assessmentData
      this.tableData = res.data.tableData
      this.orgInfo = res.data.orgInfo
      this.tableData.map(one=>{
        one.child.map(two=>{
          two.child.map(three=>{
            three.child.map(four=>{
              four.content = four.content.replaceAll('\n','<br/>')
              console.log(four.content)
            })
          })
        })
      })
    }
  },
  filters: {},
  watch: {},
}
</script>

<style scoped lang="scss">
.detail-wrapper {
  .detail-box {
    h2 {
      text-align: center;
      font-size: 32px;
      line-height: 200%;
    }

    .info-item {
      font-size: 16px;
      line-height: 40px;

      div {
        width: 50%;
        text-align: left;
      }
    }

    .top-table {
      width: 100%;
      border-top: 1px solid #333;
      border-left: 1px solid #333;

      td {
        border-bottom: 1px solid #333;
        border-right: 1px solid #333;
        font-size: 16px;
        padding: 5px;
        text-align: center;

        &.active {
          font-weight: bold;
        }

        &.left {
          text-align: left;
        }
      }
    }

    .matters {
      padding: 10px 0;

      .matters-title {
        font-size: 18px;
        line-height: 40px;
        text-align: left;
      }

      .matters-content {
        font-size: 16px;
        line-height: 150%;
      }
    }

    .score-box {
      h3 {
        text-align: center;
        font-size: 18px;
        line-height: 200%;
      }

      .score-table {
        width: 100%;
        border-top: 1px solid #333;
        border-left: 1px solid #333;

        td {
          border-bottom: 1px solid #333;
          border-right: 1px solid #333;
          font-size: 16px;
          padding: 5px;
          text-align: left;

          &.active {
            font-weight: bold;
            text-align: center;
          }
        }
      }
    }
  }
}
</style>
